import { createCognitoAuth } from '@boller002/auth';
import config from './config';

// drive.oller.io's Cognito user pool. Sign-in, two-factor setup and
// authenticator changes live in @boller002/auth (~/workspace/oller-auth),
// shared with the other oller.io sites so they all behave the same.
const auth = createCognitoAuth({
  userPoolId: config.cognito.userPoolId,
  clientId: config.cognito.clientId,
});

export default auth;
export const { getCurrentUser, getSession, getIdToken, signOut } = auth;
